import { BaseEntity, DefaultResponseWithData } from "../system";
import { IPart } from './../Part';

export interface GetEbayListingBatchItems extends DefaultResponseWithData<IEbayListingBatchItem[]> { }

export interface IEbayListingBatch extends BaseEntity {
  isComplete: boolean;
  batchItems: IEbayListingBatchItem[];
}

export interface IEbayListingBatchItem extends BaseEntity {
  isListed: boolean;
  isAutomated: boolean;
  type: BatchItemType;
  errorMessage: string;

  partDataId: string;
  partData: IPart;
  ebayListingBatchId: string;
  ebayListingBatch: IEbayListingBatch;
}

export interface BulkListingStatsResponse {
  all: number;
  manual: number;
  automated: number;
  relisted: number;
  failed: number;
  errorCount: { [key: string]: number };
}

export enum BatchItemType {
  Manual,
  Automated,
  Relisted
}